<template>
  <div class="bg">
    <!-- <div style="height:1px;">1</div> -->
    <div class="container">
      <div class="head">
        <div class="logo_c">
          <img class="logo" src="@/assets/logo_youren.png" alt="厦门游仁">
        </div>
        <div class="title">加盟问卷调查表</div>
        <div class="desc">感谢您能抽出时间来填写以下内容，这将有助于我们了解您当地的学车情况</div>
      </div>
      <div class="question">
        <!-- 主要问题 -->
        <div class="item" v-for="(item, index) in questions" :key="index">
          <div class="item_title">{{parseInt(index) + 1 + '、' + item.title}}</div>
          <input class="item_input" v-if="item.type == 'input'" v-model="item.value">
          <div class="radio_c" v-if="item.type == 'radio'">
            <div class="radio">
              <input
                :id="'radio1-' + item.group"
                :name="item.group"
                value="1"
                type="radio"
                v-model="item.value"
              >
              <label :for="'radio1-' + item.group" class="radio-label">有</label>
            </div>
            <div class="radio">
              <input
                :id="'radio2-' + item.group"
                :name="item.group"
                value="0"
                type="radio"
                v-model="item.value"
              >
              <label :for="'radio2-' + item.group" class="radio-label">没有</label>
            </div>
          </div>
          <div class="sub_c" v-if="item.type == 'radio' && item.value == 1">
            <div class="item" v-for="(item2, index) in item.sub_questions" :key="index">
              <div class="item_title">{{item2.title}}</div>
              <input class="item_input" v-model="item2.value">
            </div>
          </div>
        </div>
        <div class="splice">
          <span>——————</span>
          以下非必填
          <span>——————</span>
        </div>
        <!-- 附加问题 -->
        <div class="item" v-for="(item, index) in questions_option" :key="'op-' + index">
          <div class="item_title">{{parseInt(index) + 1 + '、' + item.title}}</div>
          <input class="item_input" v-if="item.type == 'input'" v-model="item.value">
          <div class="radio_c" v-if="item.type == 'radio'">
            <div class="radio">
              <input
                :id="'radio1-' + item.group"
                :name="item.group"
                value="1"
                type="radio"
                v-model="item.value"
              >
              <label :for="'radio1-' + item.group" class="radio-label">有</label>
            </div>
            <div class="radio">
              <input
                :id="'radio2-' + item.group"
                :name="item.group"
                value="0"
                type="radio"
                v-model="item.value"
              >
              <label :for="'radio2-' + item.group" class="radio-label">没有</label>
            </div>
          </div>
          <div class="sub_c" v-if="item.type == 'radio' && item.value == 1">
            <div class="item" v-for="(item2, index) in item.sub_questions" :key="index">
              <div class="item_title">{{item2.title}}</div>
              <input class="item_input" v-model="item2.value">
            </div>
          </div>
        </div>
      </div>
      <div class="tail"></div>
    </div>
    <div class="submit">
      <button class="b7-btn" @click="onSubmit">提交</button>
      <div class="tail"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Questionnaire",
  data() {
    return {
      questions: [
        {
          title: "该怎么称呼您呢？",
          type: "input",
          key: "name",
          value: ""
        },
        {
          title: "您的联系方式是多少？",
          type: "input",
          key: "phone",
          value: ""
        },
        {
          title: "您是在哪个区域？（精确到市区）",
          type: "input",
          key: "area",
          value: ""
        },
        {
          title: "你所在区域学车价格是多少？",
          type: "input",
          key: "price",
          value: ""
        },
        {
          title: "您所在区域的考试车型有哪些？",
          type: "input",
          key: "car_type",
          value: ""
        },
        {
          title: "您所在区域有没有学校比较集中的区域？",
          type: "radio",
          key: "schools",
          value: 0,
          sub_questions: [
            {
              title: "A、学校学生学车的学费是多少？（选填）",
              key: "student_fee",
              value: ""
            }
          ]
        },
        {
          title: "您所在区域有没有工厂比较集中的区域？",
          type: "radio",
          key: "workers",
          group: "gongren",
          value: 0,
          sub_questions: [
            {
              title: "A、工人学车的学费是多少？（选填）",
              key: "worker_fee",
              value: ""
            },
            {
              title: "B、工人学车的比例是多少？（选填）",
              key: "worker_rate",
              value: ""
            }
          ]
        },
        {
          title: "您所在区域有没有白领比较集中的区域？",
          type: "radio",
          group: "bailing",
          key: "wcollars",
          value: 0,
          sub_questions: [
            {
              title: "A、白领学车的学费是多少？（选填）",
              key: "wcollars_fee",
              value: ""
            },
            {
              title: "B、白领学车的比例是多少？（选填）",
              key: "wcollars_rate",
              value: ""
            }
          ]
        }
      ],
      questions_option: [
        {
          title: "当地驾校大体分布在哪些区域？",
          key: "ds_area",
          type: "input",
          value: ""
        },
        {
          title: "当地驾校给营销的营销费用是多少？",
          key: "ds_fee",
          type: "input",
          value: ""
        },
        {
          title: "当地驾校对学员的学时要求是怎样的？",
          key: "ds_require",
          type: "input",
          value: ""
        },
        {
          title: "当地驾校的薪酬是怎么结算的？",
          key: "ds_salary",
          type: "input",
          value: ""
        },
        {
          title: "当地驾校挂靠的车辆和自营的车辆比例是怎样的？",
          key: "ds_rate",
          type: "input",
          value: ""
        },
        {
          title: "当地驾校考试指标的价格是多少？",
          key: "ds_exam_price",
          type: "input",
          value: ""
        },
        {
          title: "当地驾校考试指标的管控方式是什么样的？",
          key: "ds_indicator",
          type: "input",
          value: ""
        }
      ]
    };
  },
  created() {},
  methods: {
    query(url, params, callback) {
      this.$indicator.open("请求中...");
      this.$axios
        .post(url, params)
        .then(res => {
          this.$indicator.close();
          console.log(res.data);
          if (res.data.err) {
            return this.$toast(res.data.msg);
          }
          callback && callback(res.data.data);
        })
        .catch(e => {
          console.log(e);
          this.$toast("请求失败");
          this.$indicator.close();
        });
    },
    onSubmit() {
      let questions = this.questions.concat(this.questions_option);
      let obj = {};
      for (let val1 of questions) {
        obj[val1.key] = val1.value;
        if (!val1.sub_questions) {
          continue;
        }
        for (let val2 of val1.sub_questions) {
          obj[val2.key] = val2.value;
        }
      }
      console.log(obj);
      let require = ["name", "phone", "area", "price", "car_type", "schools"];
      for (let key in obj) {
        if (require.indexOf(key) != -1 && !obj[key]) {
          this.$toast("请完成必填内容！");
          return;
        }
      }

      if (!this.$util.validateName(obj.name)) {
        this.$toast("请输入正确的姓名");
        return;
      }
      if (!this.$util.validateMobile(obj.phone)) {
        this.$toast("请输入正确的手机号码");
        return;
      }

      this.query("/phoneapi/questionnaire", { questionnaire: obj }, data => {
        this.$messagebox.alert("提交成功！").then(action => {
          this.$router.push({ path: "/" });
        });
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  /* background-image: url("src/assets/pc-04-04.png"); */
}
.container {
  box-shadow: 0px 0px 8px #999;
  width: 1380px;
  margin: 94px auto;
}
.logo_c {
  padding: 50px;
  height: 40px;
}
.logo {
  float: left;
}
.title {
  font-size: 44px;
  font-weight: 600;
  color: #666;
}
.desc {
  margin-top: 40px;
  font-size: 30px;
  color: #666;
}
.question {
  margin: 40px 170px;
  font-size: 30px;
}
.item {
  color: #666;
  margin-bottom: 58px;
}
.item_title {
  text-align: left;
}
.item_input {
  color: #666;
  margin: 30px 50px;
  font-size: 30px;
  display: block;
  height: 28px;
  width: 410px;
  padding: 10px;
  border: 2px solid #ccc;
}
.radio_c {
  margin: 30px 50px;
  height: 50px;
}

.radio {
  display: inline-block;
  width: 250px;
  float: left;
}

.radio input[type="radio"] {
  position: absolute;
  opacity: 0;
}
.radio input[type="radio"] + .radio-label:before {
  content: "";
  background: #fff;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 30px;
  height: 30px;
  position: relative;
  top: 0px;
  margin-right: 15px;
  vertical-align: top;
  cursor: pointer;
}
.radio input[type="radio"]:checked + .radio-label:before {
  background-color: #666;
  box-shadow: inset 0 0 0 5px #fff;
}
.sub_c {
  margin-left: 45px;
}
.splice {
  color: #ec6841;
  font-size: 28px;
  line-height: 50px;
  margin-top: 120px;
  margin-bottom: 90px;
}
.splice span {
  font-size: 17px;
  line-height: 50px;
}
.tail {
  width: 100%;
  height: 60px;
}
.b7-btn {
  margin-top: 0px;
  border: none;
  width: 350px;
  height: 97px;
  border-radius: 44px;
  background: #ec6841;
  color: white;
  font-size: 28px;
}
.b7-btn:focus {
  outline: none;
}
.b7-btn:hover {
  background: #ec7f5d;
}
.b7-btn:active {
  background: #e65b31;
}
@media screen and (max-width: 1024px) {
  .container {
    box-shadow: 0px 0px 0px #999;
    width: 100%;
    margin: 0px;
  }
  .logo {
    float: none;
    width: 200px;
  }
  .title {
    margin-top: 0px;
  }
  .desc {
    width: 76%;
    margin: auto;
    margin-top: 30px;
    font-size: 24px;
  }
  .question {
    margin: 40px 30px;
    font-size: 24px;
  }
  .item {
    margin-bottom: 35px;
  }
  .item_input {
    font-size: 24px;
    height: 24px;
    width: 380px;
    margin: 30px 40px;
  }
  .radio {
    width: 170px;
  }
  .sub_c {
    margin-left: 30px;
  }
  .splice {
    font-size: 24px;
    margin-top: 60px;
    margin-bottom: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Questionnaire.vue